export const DocumentFilters = Object.freeze({
	unprocessed: "d1",
});
